import React, {useEffect} from 'react';

import {useLocation} from 'react-router-dom';
import './AppLayout.css';
import {LogoutContainer} from '../../components/LogoutContainer/LogoutContainer';
import CookieBanner from '../../components/CookieBanner/CookieBanner';
import {DEBUGMODE} from '../../utils/constants';

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout = ({children}: AppLayoutProps) => {
  const location = useLocation();

  useEffect(() => {
    try {
      // trying to use new API
      setTimeout(() => {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      }, 100);
    } catch (error) {
      // just a fallback for older browsers
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
    }
  }, [location.pathname]);

  return (
    <div className="app-wrapper">
      <ua-header title="Borgerlig vigsel">
        <LogoutContainer />
      </ua-header>
      {DEBUGMODE && <div className="bg-danger text-white font-weight-bold px-4 py-2">Testmiljö</div>}
      <div className="container-wrapper content-wrapper">{children}</div>
      <ua-footer-pre-populated></ua-footer-pre-populated>
      <CookieBanner />
    </div>
  );
};

export default AppLayout;
